$(document).on('click', '.ph-closepopupme', function() {
  var flag = $(this).attr('data-flag').toString();

  if (flag === '1') {
    $.colorbox.close();
    /* Var checkoutUrl = $("#ultimateAddress").attr('action');
       window.location.href = checkoutUrl; */

    $('#ultimateAddress').submit();
  } else {
    $.colorbox.close();
  }
});
